import { Icon } from '@ellucian/ds-icons/lib';
import { withStyles } from '@ellucian/react-design-system/core/styles';
import { zIndexModal } from '@ellucian/react-design-system/core/styles/tokens';
import {
    Paper,
} from '@ellucian/react-design-system/core';
import Popper from '@mui/material/Popper/Popper';
import * as React from 'react';

const random = () => Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

const styles = () => ({
    container: {
        alignSelf: 'center',
        cursor: 'pointer',
        display: 'inline-flex',
    },
    paperWithoutScroll: {
        marginLeft: '8px',
        marginTop: '-18px',
        padding: '20px',
        width: '400px',
        maxHeight: '500px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    paperWithScroll: {
        marginLeft: '8px',
        marginTop: '-18px',
        padding: '20px',
        width: '400px',
        maxHeight: '500px',
        overflow: 'auto'
    },
    popper: {
        zIndex: zIndexModal,
    },
    typography: {
        fontSize: '11px',
    },
} as any);

export interface ILookupPreviewElement {
    header: string;
    body:
    {
        label: string,
        value: string
    }[];
    templateLink?: {
        label: string,
        onClick: (event: any) => void
    }
}

export interface ILookupPreviewProps {
    modifiers?: any;
    container?: any;
    classes?: any;
    iconName?: string;
    element: JSX.Element;
    disablePortal?: boolean;
    placement?: any;
    previewInField?: boolean
}

export interface ILookupPreviewState {
    anchorEl: any;
}

export class LookupPreviewInternal extends React.Component<ILookupPreviewProps, ILookupPreviewState> {

    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null
        };
    }

    public handleClick = (event) => {
        if (event && event.currentTarget) {
            this.setState({
                anchorEl: event.currentTarget
            });
        }
    }

    public handleClose = (event) => {
        if (event) {
            // mouse leaving from preview icon
            if (event.currentTarget && event.currentTarget.tagName === 'svg') {
                if (event.relatedTarget && event.relatedTarget.tagName === 'DIV' ) {
                    if (event.relatedTarget.getAttribute('role') === 'tooltip') { // mouse entering preview popper
                        this.setState({
                            anchorEl: event.currentTarget
                        });
                    } else {
                        this.setState({
                            anchorEl: null
                        });
                    }
                }
            } else { // mouse leaving from elsewhere other than preview icon
                this.setState({
                    anchorEl: null
                });
            }
        }
    }

    public render() {
        const {
            classes,
            container,
            modifiers,
            iconName,
            element,
            disablePortal,
            placement,
            previewInField
        } = this.props;
        const {
            anchorEl,
        } = this.state;

        return (
            <div className={classes.container}>
                <Icon
                    id={`${random()}_LookupPreviewIcon`}
                    name={iconName ?? 'info'}
                    data-ui="menu-item-preview-icon"
                    className={classes.icon}
                    onMouseEnter={this.handleClick}
                    onMouseLeave={this.handleClose}
                    onWheel={this.handleClose}
                />
                <Popper
                    id={`${random()}_LookupPreviewPopper`}
                    data-ui="menu-item-preview-popper"
                    open={Boolean(anchorEl)}
                    className={classes.popper}
                    placement={(placement) ? placement : 'right-start'}
                    onMouseLeave={this.handleClose}
                    anchorEl={anchorEl}
                    disablePortal={(disablePortal) ? disablePortal : false}
                    container={container || null}
                    modifiers={modifiers}

                >
                    <Paper
                        id={`${random()}_LookupPreviewPaper`}
                        className={(previewInField) ? classes.paperWithScroll : classes.paperWithoutScroll}
                    >
                        <React.Fragment key={random() + '_PreviewElementFragment'}>
                            {element || null}
                        </React.Fragment>
                    </Paper>
                </Popper>
            </div>
        );
    }
}
export default [
    withStyles(styles),
].reduce((memo, hoc: (it: any) => any) => hoc(memo), LookupPreviewInternal);
